import { createSlice } from "@reduxjs/toolkit";
import { getLabTestsClaims } from "../../reducer/insuranceLabTests/insuranceLabTestsReducer";

const initialState = {
  data: {
    claims: [],
    pagination: {},
  },
  isLoading: false,
  error: null,
};

const labTestsClaimsSlice = createSlice({
  name: "labTestsClaims",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLabTestsClaims.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getLabTestsClaims.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || {};
      })
      .addCase(getLabTestsClaims.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default labTestsClaimsSlice.reducer;
